export default __webpack_public_path__ + "static/media/Clients.7e9fdb5e.svg";